"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixMultiPolygon = exports.cropToTitleBoundaries = void 0;
const turf_1 = require("@turf/turf");
// @ts-ignore
const polyclip_ts_1 = require("polyclip-ts");
const geojson_converters_1 = require("../geojson-converters");
/**
 * Crops all the features to within the title boundary - with a small border
 *
 * @param features Features to crop
 * @param boundaries The boundary to crop the features into
 * @param borderWidthMeters Come in by this distance from the border edges
 * @returns A feature collection containing only data inside the boundaries
 */
function cropToTitleBoundaries(features, boundaries, borderWidthMeters) {
    const bufferBoundary = (0, turf_1.buffer)((0, geojson_converters_1.flattenFeatureCollection)(boundaries), -borderWidthMeters, {
        units: 'meters',
    });
    const intersected = features.features.map((feature) => {
        const overlap = (0, polyclip_ts_1.intersection)(bufferBoundary.geometry.coordinates, feature.geometry.coordinates);
        if (overlap.length > 0) {
            return {
                ...feature,
                geometry: {
                    type: 'MultiPolygon',
                    coordinates: overlap,
                },
            };
        }
        return null;
    });
    const remaining = intersected.filter((f) => f !== null);
    return (0, geojson_converters_1.flattenMultiFeatureCollection)((0, turf_1.featureCollection)(remaining));
}
exports.cropToTitleBoundaries = cropToTitleBoundaries;
/**
 * Sometimes the crop to boundary operation will result in polygons with too few
 * coordinates. I think these are when cropping a polygon that is already on the
 * border.
 * Removing them is safe, as they aren't visible anyway, and just cause other parts of
 * the system to crash.
 *
 * @param geometry
 */
function fixMultiPolygon(geometry) {
    return {
        ...geometry,
        coordinates: geometry.coordinates.filter((polygon) => {
            const outerRing = polygon[0];
            return outerRing.length >= 4;
        }),
    };
}
exports.fixMultiPolygon = fixMultiPolygon;
